import { gql } from '@apollo/client';
const SET_WAREHOUSE_RELEASE_COMPONENT_VARIANT_CONSUMPTION_OVERRIDE = gql `
  mutation SetWarehouseReleaseComponentVariantConsumptionOverride(
    $warehouseReleaseComponentVariantId: ID!
    $value: Float!
  ) {
    setWarehouseReleaseComponentVariantConsumptionOverride(
      warehouseReleaseComponentVariantId: $warehouseReleaseComponentVariantId
      value: $value
    ) {
      warehouseReleaseComponentVariant {
        id
      }
    }
  }
`;
export default SET_WAREHOUSE_RELEASE_COMPONENT_VARIANT_CONSUMPTION_OVERRIDE;
